'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { CustomRegistration } from '@components/CustomRegistration';
import cn from './style.module.scss';
export const ATHLON_MAGENTA_REGISTRATION_ID = 'wharfRegistrationID';
export default function WharfRegistration(props: any) {
  const { locale, links, leadConfig } = props;
  return (
    <Stack component="section" className={cn.wharfRegistrationWrapper}>
      <Box className={cn.wharfRegistrationInner}>
        <Box className={cn.wharfRegistrationHeader}>
          <Box className={cn.wharfRegistrationHeader__element}>
            <ParallaxText
              variant="h2"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(
                props.locale.section['ransomRegistrationNewHeading']
              )}
            </ParallaxText>
          </Box>
        </Box>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.wharfRegistrationForm}>
            <CustomRegistration
              t={locale.section}
              scrollId={ATHLON_MAGENTA_REGISTRATION_ID}
              successPopUpLink={links.successPopupRedirection}
              privacyPolicyLink={links.privacyPolicy}
              termsAndConditionsLink={links.termsAndConditions}
              formId={leadConfig.formId}
              formType={leadConfig.formType}
              projectName={leadConfig.projectName}
              variant="modal"
              className={cn.wharfRegistrationBlock}
              submitBlockClassName={cn.wharfRegistrationSubmitBlock}
              listClassName={cn.wharfRegistrationList}
              inputClassName={cn.wharfRegistrationElement}
              elementClassName={cn.wharfRegistrationInput}
              authClassName={cn.wharfRegistrationAuth}
              submitClassName={cn.wharfRegistrationButton}
              wrapperClassName={cn.wharfRegistrationSuccessWrapper}
              contentClassName={cn.wharfRegistrationSuccessContent}
              buttonClassName={cn.wharfRegistrationSuccessButton}
            />
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
